import React from "react";

import { RxCross1 } from "react-icons/rx";
const DisclaimerModal = ({ isOpen, onClose, onAccept }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 px-4"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-md md:max-w-lg h-auto max-h-[90vh] rounded-lg p-4 relative shadow-lg overflow-y-auto relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="text-gray-600 text-xl font-bold absolute right-3"
        >
          <RxCross1 size={16} />
        </button>
        <h3 className="text-lg font-semibold mb-4">
          Welcome to Niki - NECA's Virtual Expert.
        </h3>
        <p className="text-sm mb-2">
          Niki provides general guidance on electrical and communications
          matters. Responses are powered by AI and may not be always 100%
          accurate.
        </p>
        <p className="text-sm mb-2">
          For tailored and verified advice, contact our specialist team on{" "}
          <strong>1300 361 099</strong>.
        </p>
        <p className="text-sm mb-2">
          By clicking Accept, you agree to our{" "}
          <a
            href="https://www.neca.asn.au/branch/niki-terms-conditions"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            Terms and Conditions
          </a>
          , and acknowledge that NECA is not liable for any reliance on Niki’s
          responses.
        </p>

        <div className="mt-4 flex flex-col sm:flex-row justify-end sm:gap-4 gap-2">
          <button
            onClick={() => {
              onClose();
            }}
            className="w-full sm:w-auto px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-sm"
          >
            Decline
          </button>
          <button
            onClick={onAccept}
            className="w-full sm:w-auto px-4 py-2 rounded bg-[#00AEEF] hover:bg-[#2e82a0] text-white text-sm"
          >
            Accept
          </button>
        </div>

        <div className="mt-2 text-right">
          <a
            href="https://www.neca.asn.au/branch/niki-terms-conditions"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline text-xs"
          >
            Full Terms & Conditions
          </a>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerModal;
